var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-scroll-y-reverse-transition',{attrs:{"hide-on-leave":""}},[(_vm.trigger)?_c('v-card',_vm._b({staticClass:"pa-3 rounded-lg",attrs:{"color":"white","elevation":"0"}},'v-card',_vm.$attrs,false),[_c('span',{staticClass:"black2--text ehc-card-content"},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }